import React from 'react'

import { Role, Booking } from '../../../types'
import { formatDate, useIsAgent } from '../../../common'

export const BookingAudit: React.FC<{
  booking: Booking
  className?: string
}> = ({ booking, className = 'mb-3 fz-18' }) => {
  const isAdmin = useIsAgent(Role.Admin)

  if (!isAdmin) return null

  return (
    <div className={className}>
      <table>
        <tbody>
          <tr>
            <td>Booking ID:</td>
            <td className="pl-3">{booking?.id}</td>
          </tr>
          <tr>
            <td>Inserted at:</td>
            <td className="pl-3">
              {formatDate(booking?.insertedAt, 'DD MMMM YYYY - hh:mm:ss A')}
            </td>
          </tr>
          <tr>
            <td>Last updated:</td>
            <td className="pl-3">
              {formatDate(booking?.updatedAt, 'DD MMMM YYYY - hh:mm:ss A')}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
